import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Experiences`}</h2>
    <ProjectCard title="Future Youth Association" link="https://www.facebook.com/futureyouth" bg=" linear-gradient(135deg, #667eea 0%, #764ba2 100%);" mdxType="ProjectCard">
Future Youth Association 
is the place that started all of me.In 2018,I started learning programming there and 
Enjoyed coding over time and did multiple knowledge sharing programs with over 40+ attendees in technologies like React,Web foundation ,python and building APIs with Django.
    </ProjectCard>
    <ProjectCard title="TETHWIN " link="/" bg=" linear-gradient(to right, #b8cbb8 0%, #b8cbb8 0%, #b465da 0%, #cf6cc9 33%, #ee609c 66%, #ee609c 100%);" mdxType="ProjectCard">
Experienced in working with an agile team especially in building customer-facing web apps and help push the Company possibilities beyond limits.
    </ProjectCard>
    <h2>{`My Work`}</h2>
    <ProjectCard title="SIIT" link="/shaniit.org" bg=" linear-gradient(to bottom, #7028e4 0%, #e5b2ca 300%);" mdxType="ProjectCard">
Shan institute of information technology
 is the project that I am proud of.It is a tech wiki for Shan ethnic in Myanmar currently sharing over 70+ articles about technology and computer science.And it is the first place that would come to mind if you want to know about all the tech related events happening in Shan State like barcamps etc.
I was part of all the frontend UI,administrations and NLP tools like Syllable breaker. 
    </ProjectCard>
    <ProjectCard title="ESHMI" link="/" bg="linear-gradient(to bottom, #7028e4 0%, #e5b2ca 200%);" mdxType="ProjectCard">
Ei san's homemade inspiration,ESHMI is a website that you would look up when you are hungry and miss our traditional Burmese foods.Eshmi is also a cooking class teaching all about Burmese Food and they also have a huge youtube channel .
I was part of their sharing website as a frontend UI ,admin administrations and  application logics dev.
    </ProjectCard>
    <ProjectCard title="Robotics" link="/" bg="linear-gradient(60deg, #3d3393 0%, #2b76b9 37%, #2cacd1 65%, #35eb93 150%);" mdxType="ProjectCard">
Developed application  for automated food delivering robots for covid quarantine centers.
    </ProjectCard>
    <ProjectCard title="My Youtube" link="https://www.youtube.com/channel/UC_RfEQCC3gL2AzsFFAABikg" bg="  linear-gradient(to bottom, #007adf 0%, #00ecbc 140%);" mdxType="ProjectCard">
I am currenty sharing all about Frontend Development on Youtube during these hard days.
Currently over 70+ videos all About React,Javascript ,HTML CSS ,design and more . 
    </ProjectCard>
    <ProjectCard title="Coding is Hobby" link="/" bg="  linear-gradient(to right, #007adf 0%, #00ecbc 180%);" mdxType="ProjectCard">
Experienced in building over 20+ websites and applications dealing with Restful apis and have a strong understanding about authentication and SEO.
Love writing scalable and controllable CSS and have a strong understanding in CSS architectures like BEM , OOCSS and Utility first CSS.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      